import { useReveal } from "@/hooks/useReveal";

const pillars = [
  {
    icon: "ri-code-box-line",
    title: "Custom Software",
    body: "Tailored applications built from the ground up to solve your specific business challenges. We architect, code, and deploy solutions that fit your workflow.",
  },
  {
    icon: "ri-lightbulb-line",
    title: "IT Consulting",
    body: "Strategic technology guidance to help you make informed decisions, optimize processes, and implement modern tools that drive growth and efficiency.",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "Digital Marketing",
    body: "End-to-end marketing strategies that amplify your brand presence, attract the right audience, and convert engagement into measurable business results.",
  },
];

export default function Philosophy() {
  const ref = useReveal<HTMLDivElement>();
  return (
    <section ref={ref} id="about" className="bg-sand py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7" data-reveal>
            <span className="text-xs uppercase tracking-widest2 text-ink/60">Our expertise</span>
            <h2 className="mt-4 text-display text-4xl md:text-6xl leading-[1.05] text-balance">
              Technology and marketing <span className="italic font-light">united</span> in one growth strategy.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pl-12" data-reveal data-reveal-delay="120">
            <p className="text-ink/70 text-base md:text-lg leading-relaxed">
              We help companies not only create technology-driven products, but also effectively
              bring them to market, attract users, and scale their business. From idea to launch
              and ongoing support.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {pillars.map((p, i) => (
            <div
              key={p.title}
              data-reveal
              data-reveal-delay={`${i * 100}`}
              className="group rounded-3xl bg-cream p-8 md:p-10 border border-ink/5 hover:border-ink/15 transition-colors cursor-default"
            >
              <span className="inline-flex w-12 h-12 items-center justify-center rounded-2xl bg-ink text-lime-accent">
                <i className={`${p.icon} text-2xl`} />
              </span>
              <h3 className="text-display text-2xl md:text-3xl mt-6">{p.title}</h3>
              <p className="text-ink/65 mt-3 text-sm md:text-base leading-relaxed">{p.body}</p>
              <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest2 text-ink/60 group-hover:text-ink transition-colors">
                <span className="h-px w-8 bg-ink/40 group-hover:w-12 transition-all" />
                {String(i + 1).padStart(2, "0")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}